console.log('Consent Booting');
document.addEventListener("DOMContentLoaded", function() {
    console.log('Consent Loading')
    import("./CookieConsent").then(module => {
      console.log('Consent Started')
      new module.default()
    });
});
